import classNames from 'classnames/bind';
import styles from './TipPreviews.module.scss';
import TitleComp from '~/component/TitleComp';
import { useContext, useEffect, useState } from 'react';
import { FetchDataContext } from '~/component/Context/FetchDataProvider';
import TipItem from '../TipCards/TipItem';
import TipList from '../TipCards/TipList';
import TitleComp2 from '~/component/TitleComp2';
import useWindowWidth from '~/hooks/useWindowWidth';

const cx = classNames.bind(styles);

function TipPreviews() {
  const { tips, loadTips } = useContext(FetchDataContext);

  useEffect(() => {
    loadTips();
  }, []);


  
  const windowWidth = useWindowWidth();
  const [slideNumber, setSliceNumber] = useState(7);

  useEffect(() => {
    if (windowWidth === 6) {
      setSliceNumber(7);
    } else if (windowWidth === 5) {
      setSliceNumber(5);
    } else if (windowWidth === 4) {
      setSliceNumber(4);
    }
  }, [windowWidth]);

  return (
    <div className={cx('wrapper')}>
      <TitleComp2 className={cx("title")}>Lập trình</TitleComp2>
      <div className={cx('list')}>
        {tips ? <TipList className={cx("li")} data={tips.slice(0, slideNumber)} type="" hidescroll={true} loadTips={loadTips} /> : ''}
      </div>
    </div>
  );
}

export default TipPreviews;
